import {ImageCTACard, ImageCTACardProps} from 'src/component/partial/ImageCTACard';

export const SubscriptionCTACard = ({
  trackAction = '',
  ...props
}: ImageCTACardProps & {trackAction?: string}) => (
  <ImageCTACard
    headline="Become a member"
    href="/profile?tab=manage"
    imageUrl="/image/recover-password.jpg"
    lede="Become a Tally Health™ member today, discover your TallyAge™, and get science-backed tools to unlock additional years of health and vitality."
    {...props}
  />
);
